module.exports = __webpack_public_path__ + "img/banner1.165ee88a.png";